// extracted by mini-css-extract-plugin
module.exports = {"AdditionalMaterials":"AdditionalMaterials_AdditionalMaterials__cc4VQ"};